<template>
	<div class="home">
		<loadout-manager-modal />
		<side-panel ref="sidePanel">
			<template #header>
				<div class="panel-title">
					<div class="material-icons" @click="swipeLeft">arrow_left</div>
					<div class="title-label">{{ panelTitle }}</div>
					<div class="material-icons" @click="swipeRight">arrow_right</div>
				</div>
			</template>
			<template #body>
				<transition name="side-panel">
					<filters-list v-if="panelView == 0" v-model:filters="filters" @filters-applied="$refs.sidePanel.close()" />
					<loadout-manager v-else-if="panelView == 1" @save="loadoutManagerState = false" />
				</transition>
			</template>
		</side-panel>
		<div class="view-window" ref="viewWindow">
			<card-list ref="cardsList" :data-getter="getCards" />
		</div>
	</div>
</template>

<script>

import { cloneDeep }				from 'lodash';

import CardList							from '@/components/CardList';
import FiltersList					from '@/components/FiltersList';
import LoadoutManagerModal	from '@/components/LoadoutManagerModal';
import LoadoutManager				from '@/components/LoadoutManager';
import SidePanel						from '@/components/SidePanel';

import { FILTERS_DEFAULT }	from '@/utils/Filters';
import { getCards }					from '@/utils/CardsGetter';
import { openManager }			from '@/utils/LoadoutList';

export default {
	name: 'Home',
	components: {
		CardList,
		FiltersList,
		LoadoutManager,
		LoadoutManagerModal,
		SidePanel
	},
	data() {
		return {
			panelViews: [ 'filters', 'loadout manager' ],
			panelView: 0,
			filters: cloneDeep(FILTERS_DEFAULT),
			cards: []
		};
	},
	computed: {
		loadoutManagerState: {
			get() {
				return openManager.value;
			},
			set(value) {
				openManager.value = value;
			}
		},
		panelTitle() {
			return this.panelViews[this.panelView];
		}
	},
	watch: {
		filters: {
			deep: true,
			handler() {
				this.$refs.cardsList.reset();
				this.cards = getCards(this.filters);
			}
		},
		loadoutManagerState(isOpen) {
			if (isOpen)
				this.panelView = this.panelViews.indexOf('loadout manager');
		}
	},
	mounted() {
		this.cards = getCards(this.filters);
	},
	methods: {
		swipe(dir) {
			const max = this.panelViews.length;
			this.panelView = (this.panelView + max + dir) % max;
		},
		swipeLeft() {
			return this.swipe(-1);
		},
		swipeRight() {
			return this.swipe(1);
		},
		getCards(from, size) {
			return getCards(this.filters, from, size);
		}
	}
};
</script>

<style lang="scss">
@import '@/assets/colors.scss';
.hl-hover:hover {
	background: var(--lighter-blue);
}
.hl-hover-danger:hover {
	background: $danger;
}
.scrollable {
	overflow: auto;
	&::-webkit-scrollbar {
		width: 10px;
		height: 15px;
	}
	&::-webkit-scrollbar-track {
		border-radius: 10px;
		background-color: rgba(255, 255, 255, 0.1);
	}
	&::-webkit-scrollbar-thumb {
		background-image: linear-gradient(45deg, #00aeff, #a68eff);
		border-radius: 10px;
		-webkit-box-shadow: rgba(0,0,0,.12) 0 3px 13px 1px;
	}
}
.side-panel-enter-active,
.side-panel-leave-active {
	transition: opacity 300ms ease-out;
}

.side-panel-enter-from,
.side-panel-leave-to {
	opacity: 0;
}

.home, .home>* {
	height: 100%;
}
.home {
	display: flex;
	background: #484848;
	@media (min-width: 1280px) {
		>.side-panel > .panel {
			flex-direction: row-reverse;
		}
	}
	@media (max-width: 1279px) {
		flex-direction: row-reverse;
	}
	.panel-title {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
		user-select: none;
		.material-icons {
			width: 32px;
			font-size: 38px;
			cursor: pointer;
		}
		.title-label {
			flex: auto;
			text-transform: capitalize;
			text-align: center;
			cursor: default;
		}
	}

	.view-window {
		display: flex;
		flex: auto;
		height: 100%;
		width: calc(100% - var(--closed-side-panel-width));
	}
}
.no-select {
	user-select: none;
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
}
.btn {
	color: white;
	font-size: 16px;
	padding: 5px 10px;
	min-width: 75px;
	border-radius: 5px;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 250ms ease-in-out;
	&.round {
		border-radius: 50%;
	}
	&:hover {
		cursor: pointer;
		background: $light-primary;
	}
	&.primary {
		background: $primary;
	}
	&.danger {
		background: $danger;
	}
	&.text-danger {
		color: $danger;
	}
	&:hover {
		background: #fff2;
	}
	&.danger,
	&.text-danger {
		&:hover {
			background: $light-danger;
			color: white;
		}
	}
	&[disabled=true] {
		&.danger,
		&.primary {
			background: #bbb;
		}
		pointer-events: none;
		color: #666;
		cursor: default;
	}
}
</style>
